<script setup lang="ts">
  import { Primitive, useForwardProps, type PrimitiveProps } from "radix-vue"
  import Icon from "@/components/ui/icons/Icon.vue"

  const props = defineProps<PrimitiveProps>()
  const forwardedProps = useForwardProps(props)
</script>

<template>
  <Primitive v-bind="forwardedProps" data-testid="pin-input-separator">
    <slot>
      <Icon name="Dot" size="lg" />
    </slot>
  </Primitive>
</template>
